import { ClientConnectCustomFieldSet } from "./types";

export const saveCustomFieldSet = async (sid: string, fieldSet: ClientConnectCustomFieldSet): Promise<boolean> => {
    try {
        const finalFieldSets = [];
        const previousCustomFieldSets = await getCustomFieldSet(sid);

        for (let i = 0; i < previousCustomFieldSets.length; i++) {
            finalFieldSets.push(previousCustomFieldSets[i]);
            if (fieldSet.fieldSetName === previousCustomFieldSets[i].fieldSetName) {
                alert('Field Set Name already exists!')
                return false;
            }
        }

        finalFieldSets.push(fieldSet);

        fetch(`saveprofile.asp?pname=ClientConnectCustomFieldSets&SessionID=${sid}`, {
            method: "POST",
            body: `<Root><CustomFieldSets>${JSON.stringify(finalFieldSets)}</CustomFieldSets></Root>`
        });
        return true;
    } catch (e) {
        console.log('Unable to save Custom Field Sets: ', e)
        return false;
    }
}

export const updateCustomFieldSet = async (sid: string, fieldSet: ClientConnectCustomFieldSet, editFieldSet: ClientConnectCustomFieldSet): Promise<boolean> => {
    try {
        const finalFieldSets = [];
        const previousCustomFieldSets = await getCustomFieldSet(sid);
        for (let i = 0; i < previousCustomFieldSets.length; i++) {
            if (editFieldSet.fieldSetName === previousCustomFieldSets[i].fieldSetName) {
                previousCustomFieldSets.splice(i, 1, fieldSet);
            }
            finalFieldSets.push(previousCustomFieldSets[i]);
        }

        if (checkForDuplicateFieldSetNames(finalFieldSets)) {
            fetch(`saveprofile.asp?pname=ClientConnectCustomFieldSets&SessionID=${sid}`, {
                method: "POST",
                body: `<Root><CustomFieldSets>${JSON.stringify(finalFieldSets)}</CustomFieldSets></Root>`
            });
            return true;
        } else {
            return false;
        }
    } catch (e) {
        console.log('Unable to update Custom Field Sets: ', e)
        return false;
    }
}

export const getCustomFieldSet = async (sid: string): Promise<ClientConnectCustomFieldSet[]> => {
    try {
        var res = await fetch(`getprofile.asp?pname=ClientConnectCustomFieldSets&SessionID=${sid}`);
        var textData = await res.text();
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(textData, "text/xml");
        const customFieldSetXMLString = xmlDoc.getElementsByTagName("CustomFieldSets")[0]?.childNodes[0]?.nodeValue;
        if (customFieldSetXMLString) {
            const customFieldSetArray: ClientConnectCustomFieldSet[] = JSON.parse(customFieldSetXMLString);
            return customFieldSetArray;
        } else {
            return []
        }
    } catch (e) {
        console.log('Unable to get Custom Field Sets: ', e);
        return [];
    }
}

export const deleteCustomFieldSet = async (sid: string, fieldSetDelete: ClientConnectCustomFieldSet) => {
    try {
        const previousCustomFieldSets = await getCustomFieldSet(sid);
        const finalFieldSets = previousCustomFieldSets.map(v => {
            if (fieldSetDelete.fieldSetName === v.fieldSetName) return;
            return v;
        }).filter(v => v);
        fetch(`saveprofile.asp?pname=ClientConnectCustomFieldSets&SessionID=${sid}`, {
            method: "POST",
            body: `<Root><CustomFieldSets>${JSON.stringify(finalFieldSets)}</CustomFieldSets></Root>`
        });
        return true;
    } catch (e) {
        console.log('Unable to delete Custom Field Sets: ', e)
        return false;
    }
}

const checkForDuplicateFieldSetNames = (finalFieldSets): boolean => {
    // Set to store unique field set names
    const uniqueFieldSetNames = new Set();
    // Flag to determine whether there are duplicate field set names
    let hasDuplicates = false;
    for (let j = 0; j < finalFieldSets.length; j++) {
        const currentFieldSet = finalFieldSets[j];
        // Check if the field set name has already been encountered
        if (uniqueFieldSetNames.has(currentFieldSet.fieldSetName)) {
            hasDuplicates = true;
            break; // Break out of the loop if there are duplicates
        }
        // Add the current field set name to the set
        uniqueFieldSetNames.add(currentFieldSet.fieldSetName);
    }
    if (hasDuplicates) {
        alert('Field Set Name already exists!')
        return false;
    } else {
        return true;
    }
}